<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a routerLink="/page/dashboard"
        ><i class="icon text-info fa fa-home"></i
      ></a>
    </li>

    <li class="breadcrumb-item active" aria-current="page">
      {{ currentProject.name }} - Change Log
    </li>
  </ol>
</nav>

<div class="row">
  <div class="col-md-12">
    <div class="card main-card mb-3">
      <div class="card-body">
        <div class="row mb-3">
          <div
            class="col-md-12 col-xl-12 d-flex text-left"
            style="margin: 0px 10px; padding: 8px"
          >
            <div
              class="d-flex justify-content-between align-items-center"
              style="width: 100%"
            >
              <div class="d-flex">
                <select
                  [(ngModel)]="selectedVersion"
                  style="height: 35px !important"
                  (change)="onFilterChange()"
                  class="card px-3 py-2 m-2"
                >
                  <option
                    style="color: #3f6ad8"
                    *ngFor="let item of versionList"
                    [value]="item.id"
                  >
                    {{ item.version }} ({{
                      item.releaseDate | date : "dd MMM yyyy"
                    }})
                  </option>
                </select>
                <select
                  [(ngModel)]="selectedEnv"
                  style="height: 35px !important"
                  (change)="onFilterChange()"
                  class="card px-3 py-2 m-2"
                >
                  <option style="color: #3f6ad8" value="dev" selected>
                    Dev
                  </option>
                  <option style="color: #3f6ad8" value="qa">QA</option>
                  <option style="color: #3f6ad8" value="prod">Prod</option>
                </select>
              </div>
              <!--if active tab is audit tab-->
              <div
                class="pagination-controls"
                *ngIf="activeTabId !== 'pending-publish-tab-id'"
              >
                <button
                  class="btn btn-secondary"
                  style="height: 40px"
                  (click)="goToPreviousPage()"
                  [disabled]="currentPage === 1"
                >
                  <i class="fa fa-caret-left" style="font-size: 24px"></i>
                </button>
                <span>Page {{ currentPage }} of {{ totalPages }}</span>
                <button
                  class="btn btn-secondary"
                  style="height: 40px"
                  (click)="goToNextPage()"
                  [disabled]="currentPage === totalPages"
                >
                  <i class="fa fa-caret-right" style="font-size: 24px"></i>
                </button>
              </div>
              <!--if active tab is pending publish tab-->
              <div
                class="pagination-controls"
                *ngIf="activeTabId === 'pending-publish-tab-id'"
              >
                <button
                  class="btn btn-secondary"
                  style="height: 40px"
                  (click)="goToPublishPreviousPage()"
                  [disabled]="publishCurrentPage === 1"
                >
                  <i class="fa fa-caret-left" style="font-size: 24px"></i>
                </button>
                <span
                  >Page {{ publishCurrentPage }} of
                  {{ publishTotalPages }}</span
                >
                <button
                  class="btn btn-secondary"
                  style="height: 40px"
                  (click)="goToPublishNextPage()"
                  [disabled]="publishCurrentPage === publishTotalPages"
                >
                  <i class="fa fa-caret-right" style="font-size: 24px"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <ul
          ngbNav
          #nav="ngbNav"
          [destroyOnHide]="true"
          class="nav nav-pills"
          (navChange)="onTabChange($event)"
          [(activeId)]="activeTabId"
        >
          <li [ngbNavItem]="'pendingPublish'">
            <a ngbNavLink>
              <span (click)="onTabChange('pendingPublish')" id="pendingPublish"
                >Pending Publish</span
              >
            </a>
            <ng-template ngbNavContent>
              <div class="row">&nbsp;</div>
              <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button
                  class="btn btn-primary pd-2 md-2"
                  *ngIf="
                    publishdata?.data?.length &&
                    (selectedEnv == 'dev' || selectedEnv == 'qa')
                  "
                  (click)="updatePublishStage(publishdata?.data, selectedEnv)"
                >
                  Publish all
                </button>
              </div>
              <table class="table mt-2 pt-2 table-bordered">
                <thead>
                  <tr>
                    <th style="width: 12; font-size: large">Time Stamp</th>
                    <th style="width: 10%; font-size: large">Element Type</th>
                    <th style="width: 15%; font-size: large">Name</th>
                    <th style="width: 34%; font-size: large">
                      Pending Publish
                    </th>
                    <th
                      style="width: 29%; font-size: large"
                      *ngIf="selectedEnv == 'dev'"
                    >
                      Publish to QA
                    </th>
                    <th
                      style="width: 29%; font-size: large"
                      *ngIf="selectedEnv == 'qa'"
                    >
                      Publish to Prod
                    </th>
                    <!-- <th
                      style="width: 5%; font-size: large"
                      *ngIf="selectedEnv == 'qa' || selectedEnv == 'dev'"
                    >
                      Quick Action
                    </th> -->
                  </tr>
                </thead>
                <tbody *ngIf="publishdata?.data?.length; else noPublishData">
                  <tr *ngFor="let item of publishdata?.data">
                    <td>
                      {{ item.timestamp | date : "MM/dd/yyyy - HH:mm:ss" }}
                    </td>
                    <td>{{ item.elementType }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.pendingPublish }}</td>
                    <td *ngIf="selectedEnv == 'qa' || selectedEnv == 'dev'">
                      <button
                        *ngIf="selectedEnv == 'dev'"
                        class="btn btn-primary"
                        (click)="updatePublishStage(item, selectedEnv)"
                      >
                        Publish to QA
                      </button>
                      <button
                        *ngIf="selectedEnv == 'qa'"
                        class="btn btn-primary"
                        (click)="updatePublishStage(item, selectedEnv)"
                      >
                        Publish to prod
                      </button>
                    </td>
                  </tr>
                </tbody>
                <ng-template #noPublishData>
                  <tbody>
                    <tr>
                      <td colspan="4" class="text-center">
                        {{ "Form.NoDataAvailable" | translate }}
                      </td>
                    </tr>
                  </tbody>
                </ng-template>
              </table>
            </ng-template>
          </li>

          <li [ngbNavItem]="'auditLog'">
            <a ngbNavLink>
              <span (click)="onTabChange('auditLog')" id="auditLog"
                >Audit Log</span
              >
            </a>
            <ng-template ngbNavContent>
              <div class="row">&nbsp;</div>
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th style="width: 12; font-size: large">Time Stamp</th>
                    <th style="width: 10%; font-size: large">Element Type</th>
                    <th style="width: 15%; font-size: large">Name</th>
                    <th style="width: 64%; font-size: large">Changes</th>
                  </tr>
                </thead>
                <tbody *ngIf="auditTrailData?.data?.length; else noData">
                  <tr *ngFor="let item of auditTrailData?.data">
                    <td>
                      {{ item?.timestamp | date : "MM/dd/yyyy - HH:mm:ss" }}
                    </td>
                    <td>{{ item?.elementType }}</td>
                    <td>{{ item?.name }}</td>
                    <td [innerHTML]="sanitizeHtml(item.changes)"></td>
                  </tr>
                </tbody>
                <ng-template #noData>
                  <tbody>
                    <tr>
                      <td colspan="4" class="text-center">
                        {{ "Form.NoDataAvailable" | translate }}
                      </td>
                    </tr>
                  </tbody>
                </ng-template>
              </table>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="nav"></div>

        <div [ngbNavOutlet]="activeTabId" class="mt-2"></div>
      </div>
    </div>
  </div>
</div>
